module.exports = __webpack_public_path__ + "img/newmember_tag_trapezoid@2x.38ea15bf.png";